import { render } from "./lan-tail.vue?vue&type=template&id=ecd179dc&scoped=true"
import script from "./lan-tail.vue?vue&type=script&lang=js"
export * from "./lan-tail.vue?vue&type=script&lang=js"

import "./lan-tail.vue?vue&type=style&index=0&id=ecd179dc&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecd179dc"]])

export default __exports__